import { store } from "./store";


export const DIMENSION = {
  Desktop: "desktop",
  Tablet: "tablet",
  Mobile: "mobile",
};

export const LAYOUT = {
  Fluid: "fluid",
  Boxed: "boxed",
};

export const RADIUS = {
  Rounded: "rounded",
  Standard: "standard",
  Flat: "flat",
};

export const THEME_COLOR = {
  LightBlue: "light-blue",
  DarkBlue: "dark-blue",
  LightRed: "light-red",
  DarkRed: "dark-red",
  LightGreen: "light-green",
  DarkGreen: "dark-green",
  LightPurple: "light-purple",
  DarkPurple: "dark-purple",
  LightPink: "light-pink",
  DarkPink: "dark-pink",
};

export const NAV_COLOR = {
  Default: "default",
  Light: "light",
  Dark: "dark",
};
export const MENU_PLACEMENT = {
  Vertical: "vertical",
  Horizontal: "horizontal",
};
export const MENU_BEHAVIOUR = {
  Pinned: "pinned",
  Unpinned: "unpinned",
};

export const USER_ROLE = {
  Admin: "admin",
  Editor: "user",
};

export const ALL_CURRENCIES = [
  { code: "AF", label: "Afghanistan - Afghanis (AF)" },
  { code: "ALL", label: "Albania - Leke (ALL)" },
  { code: "DZD", label: "Algerie - Algerian dinar (DZD)" },
  { code: "USD", label: "America - Dollars (USD)" },
  { code: "AOA", label: "Angola - Kwanza (AOA)" },
  { code: "ARS", label: "Argentina - Pesos (ARS)" },
  { code: "AWG", label: "Aruba - Guilders (AWG)" },
  { code: "AUD", label: "Australia - Dollars (AUD)" },
  { code: "AZ", label: "Azerbaijan - New Manats (AZ)" },
  { code: "BSD", label: "Bahamas - Dollars (BSD)" },
  { code: "BHD", label: "Bahrain - Bahraini dinar (BHD)" },
  { code: "BDT", label: "Bangladesh - Taka (BDT)" },
  { code: "BBD", label: "Barbados - Dollars (BBD)" },
  { code: "BYR", label: "Belarus - Rubles (BYR)" },
  { code: "EUR", label: "Belgium - Euro (EUR)" },
  { code: "BZD", label: "Beliz - Dollars (BZD)" },
  { code: "BMD", label: "Bermuda - Dollars (BMD)" },
  { code: "BOB", label: "Bolivia - Bolivianos (BOB)" },
  { code: "BAM", label: "Bosnia and Herzegovina - Convertible Marka (BAM)" },
  { code: "BWP", label: "Botswana - Pula (BWP)" },
  { code: "BRL", label: "Brazil - Reais (BRL)" },
  { code: "GBP", label: "Britain - Pounds (GBP)" },
  { code: "BND", label: "Brunei Darussalam - Dollars (BND)" },
  { code: "BG", label: "Bulgaria - Leva (BG)" },
  { code: "KHR", label: "Cambodia - Riels (KHR)" },
  { code: "CAD", label: "Canada - Dollars (CAD)" },
  { code: "KYD", label: "Cayman Islands - Dollars (KYD)" },
  { code: "CLP", label: "Chile - Pesos (CLP)" },
  { code: "CNY", label: "China - Yuan Renminbi (CNY)" },
  { code: "COP", label: "Colombia - Pesos (COP)" },
  { code: "CRC", label: "Costa Rica - Colón (CRC)" },
  { code: "HRK", label: "Croatia - Kuna (HRK)" },
  { code: "CUP", label: "Cuba - Pesos (CUP)" },
  { code: "EUR", label: "Cyprus - Euro (EUR)" },
  { code: "CZK", label: "Czech Republic - Koruny (CZK)" },
  { code: "DKK", label: "Denmark - Kroner (DKK)" },
  { code: "DOP", label: "Dominican Republic - Pesos (DOP)" },
  { code: "XCD", label: "East Caribbean - Dollars (XCD)" },
  { code: "EGP", label: "Egypt - Pounds (EGP)" },
  { code: "SVC", label: "El Salvador - Colones (SVC)" },
  { code: "EUR", label: "Euro - EUR" },
  { code: "FKP", label: "Falkland Islands - Pounds (FKP)" },
  { code: "FJD", label: "Fiji - Dollars (FJD)" },
  { code: "EUR", label: "France - Euro (EUR)" },
  { code: "GHS", label: "Ghana - Cedis (GHS)" },
  { code: "GIP", label: "Gibraltar - Pounds (GIP)" },
  { code: "EUR", label: "Greece - Euro (EUR)" },
  { code: "GTQ", label: "Guatemala - Quetzales (GTQ)" },
  { code: "GGP", label: "Guernsey - Pounds (GGP)" },
  { code: "GYD", label: "Guyana - Dollars (GYD)" },
  { code: "EUR", label: "Holland - Euro (EUR)" },
  { code: "HNL", label: "Honduras - Lempiras (HNL)" },
  { code: "HKD", label: "Hong Kong - Dollars (HKD)" },
  { code: "HUF", label: "Hungary - Forint (HUF)" },
  { code: "ISK", label: "Iceland - Kronur (ISK)" },
  { code: "INR", label: "India - Rupees (INR)" },
  { code: "IDR", label: "Indonesia - Rupiahs (IDR)" },
  { code: "IRR", label: "Iran - Rials (IRR)" },
  { code: "IQD", label: "Iraq - Iraqi dinar (IQD)" },
  { code: "EUR", label: "Ireland - Euro (EUR)" },
  { code: "IMP", label: "Isle of Man - Pounds (IMP)" },
  { code: "ILS", label: "Israel - New Shekels (ILS)" },
  { code: "EUR", label: "Italy - Euro (EUR)" },
  { code: "JMD", label: "Jamaica - Dollars (JMD)" },
  { code: "JPY", label: "Japan - Yen (JPY)" },
  { code: "JEP", label: "Jersey - Pounds (JEP)" },
  { code: "KZT", label: "Kazakhstan - Tenge (KZT)" },
  { code: "KES", label: "Kenya - Kenyan Shilling (KES)" },
  { code: "KPW", label: "Korea North - Won (KPW)" },
  { code: "KRW", label: "Korea South - Won (KRW)" },
  { code: "KWD", label: "Kuwait - Kuwaiti dinar (KWD)" },
  { code: "KGS", label: "Kyrgyzstan - Soms (KGS)" },
  { code: "LAK", label: "Laos - Kips (LAK)" },
  { code: "LVL", label: "Latvia - Lati (LVL)" },
  { code: "LBP", label: "Lebanon - Pounds (LBP)" },
  { code: "LRD", label: "Liberia - Dollars (LRD)" },
  { code: "CHF", label: "Liechtenstein - Switzerland Francs (CHF)" },
  { code: "LTL", label: "Lithuania - Litai (LTL)" },
  { code: "EUR", label: "Luxembourg - Euro (EUR)" },
  { code: "MKD", label: "Macedonia - Denars (MKD)" },
  { code: "MYR", label: "Malaysia - Ringgits (MYR)" },
  { code: "EUR", label: "Malta - Euro (EUR)" },
  { code: "MUR", label: "Mauritius - Rupees (MUR)" },
  { code: "MXN", label: "Mexico - Pesos (MXN)" },
  { code: "MNT", label: "Mongolia - Tugriks (MNT)" },
  { code: "MZ", label: "Mozambique - Meticais (MZ)" },
  { code: "NAD", label: "Namibia - Dollars (NAD)" },
  { code: "NPR", label: "Nepal - Rupees (NPR)" },
  { code: "ANG", label: "Netherlands Antilles - Guilders (ANG)" },
  { code: "EUR", label: "Netherlands - Euro (EUR)" },
  { code: "NZD", label: "New Zealand - Dollars (NZD)" },
  { code: "NIO", label: "Nicaragua - Cordobas (NIO)" },
  { code: "NGN", label: "Nigeria - Nairas (NGN)" },
  { code: "KPW", label: "North Korea - Won (KPW)" },
  { code: "NOK", label: "Norway - Krone (NOK)" },
  { code: "OMR", label: "Oman - Rials (OMR)" },
  { code: "PKR", label: "Pakistan - Rupees (PKR)" },
  { code: "PAB", label: "Panama - Balboa (PAB)" },
  { code: "PYG", label: "Paraguay - Guarani (PYG)" },
  { code: "PE", label: "Peru - Nuevos Soles (PE)" },
  { code: "PHP", label: "Philippines - Pesos (PHP)" },
  { code: "PL", label: "Poland - Zlotych (PL)" },
  { code: "QAR", label: "Qatar - Rials (QAR)" },
  { code: "RO", label: "Romania - New Lei (RO)" },
  { code: "RUB", label: "Russia - Rubles (RUB)" },
  { code: "SHP", label: "Saint Helena - Pounds (SHP)" },
  { code: "SAR", label: "Saudi Arabia - Riyals (SAR)" },
  { code: "RSD", label: "Serbia - Dinars (RSD)" },
  { code: "SCR", label: "Seychelles - Rupees (SCR)" },
  { code: "SGD", label: "Singapore - Dollars (SGD)" },
  { code: "EUR", label: "Slovenia - Euro (EUR)" },
  { code: "SBD", label: "Solomon Islands - Dollars (SBD)" },
  { code: "SOS", label: "Somalia - Shillings (SOS)" },
  { code: "ZAR", label: "South Africa - Rand (ZAR)" },
  { code: "KRW", label: "South Korea - Won (KRW)" },
  { code: "EUR", label: "Spain - Euro (EUR)" },
  { code: "LKR", label: "Sri Lanka - Rupees (LKR)" },
  { code: "SRD", label: "Suriname - Dollars (SRD)" },
  { code: "SEK", label: "Sweden - Kronor (SEK)" },
  { code: "CHF", label: "Switzerland - Francs (CHF)" },
  { code: "SYP", label: "Syria - Pounds (SYP)" },
  { code: "TWD", label: "Taiwan - New Dollars (TWD)" },
  { code: "TZS", label: "Tanzania - Tanzanian Shilling (TZS)" },
  { code: "THB", label: "Thailand - Baht (THB)" },
  { code: "TTD", label: "Trinidad and Tobago - Dollars (TTD)" },
  { code: "TRY", label: "Turkey - Lira (TRY)" },
  { code: "TRL", label: "Turkey - Liras (TRL)" },
  { code: "TVD", label: "Tuvalu - Dollars (TVD)" },
  { code: "UGX", label: "Uganda - Uganda Shillings (UGX)" },
  { code: "UAH", label: "Ukraine - Hryvnia (UAH)" },
  { code: "AED", label: "United Arab Emirates - Dirham (AED)" },
  { code: "GBP", label: "United Kingdom - Pounds (GBP)" },
  { code: "USD", label: "United States - Dollars (USD)" },
  { code: "UYU", label: "Uruguay - Pesos (UYU)" },
  { code: "UZS", label: "Uzbekistan - Sums (UZS)" },
  { code: "EUR", label: "Vatican City - Euro (EUR)" },
  { code: "VEF", label: "Venezuela - Bolivares Fuertes (VEF)" },
  { code: "VND", label: "Vietnam - Dong (VND)" },
  { code: "YER", label: "Yemen - Rials (YER)" },
  { code: "ZWD", label: "Zimbabwe - Zimbabwe Dollars (ZWD)" },
];


export function formatPrice(amount) {
  // Get currency from Redux store
  const state = store.getState();
  const currency = state.settings.currency || "PKR";

  if (!amount) amount = 0;

  const formattedAmount = new Intl.NumberFormat("en-US").format(Number(amount));

  return `${formattedAmount} ${currency}`;
}
